import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// TODO: store default from prismic

export default new Vuex.Store({
  state: {
    textes: {
      mainTitle: '',
      previewTitle: ''
    },
    loading: true,
    collage: {
      sentence: {
        uid: null,
        url: null
      },
      bg: {
        uid: null,
        title: null,
        url: null
      }
    },
    privateSentences: [],
    screenshot: null,
    tutorial: false,
    sentences: [],
    backgrounds: []
  },
  mutations: {
    SET_SENTENCE: (state, payload) => {
      state.collage.sentence = payload
    },
    SET_BG: (state, payload) => {
      state.collage.bg = payload
    },
    SET_SCREENSHOT: (state, payload) => {
      state.screenshot = payload
    },
    SET_TEXTES: (state, payload) => {
      state.textes = payload
    },
    SET_LOADING: (state, payload) => {
      // console.log('setloading', payload)
      state.loading = payload
    },
    SET_ASSETS: (state, payload) => {
      state.backgrounds = payload.backgrounds
      state.sentences = [...state.privateSentences, ...payload.sentences]
      state.collage.bg = payload.backgrounds[Math.floor(Math.random() * (payload.backgrounds.length - 1))]
      state.collage.sentence = payload.sentences[Math.floor(Math.random() * (payload.sentences.length - 1))]
      state.loading = false
    },
    ADD_SENTENCES: (state, payload) => {
      state.privateSentences = payload
    },
    SET_TUTORIAL: (state, payload) => {
      state.tutorial = payload
    },
    SET_INIT: (state, payload) => {
      state.collage.bg = payload.bg
      state.collage.sentence = payload.sentence
    }
  },
  actions: {
    // FETCH_API: async (state, payload) => {
    //   const data = await state.collage.bg = payload.bg
    //   state.collage.sentence = payload.sentence
    // }
  },
  modules: {
  }
})
